import orderBy from 'lodash/orderBy';
import { Content, ContentHeroFormat } from '../../../common/models/content/Content';
import { TopicsCount } from '../../../common/models/content/TopicsCount';
import { TestIds } from '../../../assets/testIds';

export interface ITopic {
  id?: string
  name: string
  displayName?: string
  category?: string
  followed?: boolean
  dataTestId?: string
  description?: string
}

export const getImageUrl = (url: string | undefined) => {
  const imageBaseUrl = process.env.REACT_APP_STRAPI_URL;
  if (url && !url.includes('http')) {
    return imageBaseUrl?.concat(url);
  }
  return url;
};

export const getHeaderImageUrl = (content: Content | undefined) => {
  let url;
  // display collection icon in case of podcast
  if (content?.attributes?.content_collection?.data) {
    url = content?.attributes?.content_collection?.data?.attributes?.icon?.data?.attributes?.url;
  } else {
    url = content?.attributes?.content_owner?.data?.attributes?.icon?.data?.attributes?.url;
  }
  return getImageUrl(url);
};

export const getHeading = (content: Content | undefined) => {
  let heading;
  // display collection name in case of podcast
  if (content?.attributes?.content_collection?.data) {
    heading = content?.attributes?.content_collection?.data?.attributes?.title;
  } else {
    heading = content?.attributes?.content_owner?.data?.attributes?.display_name;
  }
  return heading;
};

export const getHeroFormat = (content: Content | undefined) => (
  content?.attributes?.hero?.data?.attributes?.formats?.medium ||
  content?.attributes?.hero?.data?.attributes?.formats?.small ||
  content?.attributes?.hero?.data?.attributes?.formats?.thumbnail
) as ContentHeroFormat;

export const getFormattedTestId = (input: string) => (
  input.toLowerCase().replace(/\s+/g, '-')
);

export const staticBusinessGoals: ITopic[] = [
  {
    id: '1',
    name: 'Scale my business',
    displayName: 'Scale my business',
    category: 'Business Goal',
    dataTestId: TestIds.businessGoals.scaleMyBusinessBtn,
  },
  {
    id: '2',
    name: 'Better Work/Life Balance',
    displayName: 'Better Work/Life Balance',
    category: 'Business Goal',
    dataTestId: TestIds.businessGoals.betterWorkLifeBalanceBtn,
  },
  {
    id: '3',
    name: 'Control cash flow',
    displayName: 'Control cash flow',
    category: 'Business Goal',
    dataTestId: TestIds.businessGoals.controlCashFlowBtn,
  },
];

export const staticTopicsToFollowOnModal: ITopic[] = [
  {
    id: '1',
    name: 'Hiring',
    description: 'Hire The Best People',
    followed: false,
    dataTestId: TestIds.followTopics.hiringBtn,
  },
  {
    id: '2',
    name: 'Pricing',
    description: 'Learn How The Best Do It',
    followed: false,
    dataTestId: TestIds.followTopics.pricingBtn,
  },
  {
    id: '3',
    name: 'Lead Generation',
    description: 'Learn How To Get Quality Leads',
    followed: false,
    dataTestId: TestIds.followTopics.leadGenerationBtn,
  },
  {
    id: '4',
    name: 'Technology',
    description: 'New Technologies',
    followed: false,
    dataTestId: TestIds.followTopics.technologyBtn,
  },
  {
    id: '5',
    name: 'Marketing',
    description: 'Up Your Game',
    followed: false,
    dataTestId: TestIds.followTopics.marketingBtn,
  },
];

export const getSortedTopTopics = (allTopics: TopicsCount[], getBusinessGoals = false) => {
  let result;
  const sortedTopics = orderBy(allTopics.slice(0, 19), 'name').sort();
  if (getBusinessGoals) {
    result = [...staticBusinessGoals, ...sortedTopics];
  } else {
    result = [...sortedTopics];
  }
  return result;
};
